module.exports = __webpack_public_path__ + "static/media/HalvettCondensed.178a9e75.woff";